import React, { useState } from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { generateRoadnetRoutePlanning } from "../api/monthly";

/**
 * Parses a single text field into `employee_ids`: one id, or comma-separated ids.
 */
function parseEmployeeIds(raw: string): string[] {
  return raw
    .split(/[,\s]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

const RoutePlanningGenerate = () => {
  const [employeeInput, setEmployeeInput] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const employee_ids = parseEmployeeIds(employeeInput);
    if (employee_ids.length === 0) {
      toast.error("Enter at least one employee ID.");
      return;
    }

    try {
      setLoading(true);
      const data = await generateRoadnetRoutePlanning({ employee_ids });
      const msg =
        (data && typeof data === "object" && "message" in data && typeof (data as any).message === "string"
          ? (data as any).message
          : null) || "Request completed.";
      toast.success(msg);
    } catch (error: any) {
      if (error?.response?.status === 404) {
        toast.error("Please try again later.");
      } else if (error?.response?.status === 500) {
        toast.error("Something went wrong. Please try again.");
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err: { msg?: string }) =>
            toast.error(err?.msg || "Validation error.")
          );
        } else {
          toast.error(detail?.msg || detail || error?.message || "Request failed.");
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <h3 className="text-xl font-bold text-gray-700">Route planning generate</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="my-2">
          <label className="block font-semibold mb-1" htmlFor="employee_ids">
            Employee IDs
          </label>
          <input
            id="employee_ids"
            type="text"
            value={employeeInput}
            onChange={(e) => setEmployeeInput(e.target.value)}
            className="w-full border px-3 py-2 rounded border-gray-300"
            placeholder="Employee ID(s), comma-separated if multiple"
            autoComplete="off"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2 mt-2"
        >
          Submit {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default RoutePlanningGenerate;
